import styled from 'styled-components'

function BasePublicApiIcon({ className, size = 18 }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.07143 8.25C1.82366 8.25 0 6.40234 0 4.125C0 1.84766 1.82366 0 4.07143 0C6.3192 0 8.14286 1.84766 8.14286 4.125C8.14286 4.29688 8.13437 4.46875 8.11317 4.63633L12.104 6.65586C12.8335 5.93828 13.8301 5.5 14.9286 5.5C17.1763 5.5 19 7.34766 19 9.625C19 11.9023 17.1763 13.75 14.9286 13.75C13.8301 13.75 12.8335 13.3117 12.104 12.5941L8.11317 14.6137C8.13437 14.7813 8.14286 14.9488 8.14286 15.125C8.14286 17.4023 6.3192 19.25 4.07143 19.25C1.82366 19.25 0 17.4023 0 15.125C0 12.8477 1.82366 11 4.07143 11C5.16987 11 6.16652 11.4383 6.89598 12.1559L10.8868 10.1363C10.8656 9.9687 10.8571 9.8012 10.8571 9.625C10.8571 9.4488 10.8656 9.2813 10.8868 9.1137L6.89598 7.09414C6.16652 7.81172 5.16987 8.25 4.07143 8.25Z"
        fill="#FFA114"
      />
    </svg>
  )
}

export const PublicApiIcon = styled(BasePublicApiIcon)``
